
/** 时/分/秒 转为 HH:MM:SS */
export function unitFormat(value: number) {
  return value > 0 ? `${ value < 10 ? '0' : '' }${ value }` : '00'
}

/** 将 秒钟 转化为 hh:mm:ss 格式 */
export function formatDuration(duration: number) {
  if (duration === 0) return '00:00'
  // 毫秒转成秒
  duration = Math.ceil(duration / 1000)
  // 计算小时、分钟的剩余时长
  let restDuration = duration
  // 小时
  const hours = Math.floor(restDuration / (60 * 60))
  restDuration = restDuration % (60 * 60)
  // 分钟
  const minutes = Math.floor(restDuration / (60))
  restDuration = restDuration % (60)
  // 秒钟
  const seconds = restDuration < 1 ? 1 : Math.floor(restDuration)
  return `${
    hours > 0 ? unitFormat(hours) : ''
  }${
    hours > 0 ? ':' : ''
  }${
    unitFormat(minutes)
  }:${
    unitFormat(seconds)
  }`
}

export function hasDecimal(num) {
  return /\./.test(num.toString());
}

/**
 * 判断值是否为空
 * @param str 
 * @returns 
 */
export function isNull(str) {
  if (!str || str === 'null' || str === 'undefined') {
    return true
  }
  return false
}